import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Favorite from '@material-ui/icons/Favorite';
import Description from '@material-ui/icons/Description';
import Class from '@material-ui/icons/Class';
import Button from 'components/CustomButtons/Button.jsx';
import CloudDownload from '@material-ui/icons/CloudDownload';
import { CSVLink } from "react-csv";

let counter = 0;
// function createData(name, calories, fat, carbs, protein) {
//   counter += 1;
//   return { id: counter, name, calories, fat, carbs, protein };
// }



function createData(groupName, className, number, getAnswerRate, datakey) {
    counter += 1;
    return { id: counter, groupName, className, number, getAnswerRate, datakey };
}


function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const rows = [
    { id: 'groupName', numeric: false, disablePadding: true, label: '班級名稱' },
    { id: 'number', numeric: true, disablePadding: false, label: '考試人數' },
    { id: 'getAnswerRate', numeric: true, disablePadding: false, label: '答對率' },
];




class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {/* <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell> */}
                    {rows.map(
                        row => (
                            <TableCell
                                key={row.id}
                                align={row.numeric ? 'right' : 'left'}
                                padding={row.disablePadding ? 'none' : 'default'}
                                sortDirection={orderBy === row.id ? order : false}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        ),
                        this,
                    )}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
});

let EnhancedTableToolbar = props => {
    const { numSelected, classes } = props;

    return (
        <Toolbar
            className={classNames(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <div className={classes.title}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subtitle1">
                        {numSelected} selected
          </Typography>
                ) : (
                        <Typography variant="h6" id="tableTitle">
                            Nutrition
          </Typography>
                    )}
            </div>
            <div className={classes.spacer} />
            <div className={classes.actions}>
                {numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                ) : (
                        ""
                        // <Tooltip title="Filter list">
                        //   <IconButton aria-label="Filter list">
                        //     <FilterListIcon />
                        //   </IconButton>
                        // </Tooltip>
                    )}
            </div>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
});

class EnhancedTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            order: 'asc',
            orderBy: 'examName',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 5,
            dataType: props.dataType,
        };

    }


    getData(examlist, datakey) {

        var testData = [];
        if (examlist.length > 0) {

            var checkExamNumber = examlist.findIndex(img => img.key === datakey);

            if (checkExamNumber > -1) {
                var exdata = examlist[checkExamNumber];


                var newData = [];
                var groupData = {};
                if (exdata.value.students) {


                    var students = exdata.value.students;
                    var ansTxt = exdata.value.correctAns;
                    var ans = ansTxt.split(',');
                    // var groupNo = 0;
                    var groupNo = "";
                    for (var getstudents in students) {
                        //改版
                        // groupNo =    students[getstudents].classNo;
                        // groupNo = JSON.stringify({
                        //   gradeNo: students[getstudents].gradeNo,
                        //   classNo: students[getstudents].classNo
                        // })
                        groupNo = students[getstudents].gradeNo +"-"+students[getstudents].classNo;

                        if (groupData[groupNo]) {
                            groupData[groupNo].push(students[getstudents])
                        }
                        else {
                            groupData[groupNo] = [students[getstudents]]
                        }
                    }

                    for (var groupName in groupData) {
                        var testers = groupData[groupName];
                        // var testerAnsData = testers[0].ans.split(',');
                        // var className = parseInt(testerAnsData[0]) + "年" + parseInt(testerAnsData[1]) + "班";
                        //  var groupNameJson = JSON.parse(groupName);
                        //var className = groupNameJson.gradeNo + "年" + groupNameJson.classNo+ "班";
                        var groupNoData = groupName.split('-');
                        var className = groupNoData[0] + "年" + groupNoData[1]+ "班";

                        //移除班級
                        //var getAnswer = (ans.length - 3) * testers.length;
                        var getAnswer = (ans.length ) * testers.length;

                        var getStudensAns = 0;
                        //前三個為班級等資訊
                        for (var getstudents1 in testers) {

                            var studentAnsTxt = testers[getstudents1].ans;

                            var studentAns = studentAnsTxt.split(',');
                            //移除班級
                            //for (let index = 3; index < ans.length; index++) {
                            for (let index = 0; index < ans.length; index++) {
                                const a = ans[index];
                                const s = studentAns[index];
                                if (a === s) {
                                    getStudensAns++;
                                }
                            }
                        }


                        var getAnswerRate = getStudensAns / getAnswer;
                        getAnswerRate = (Math.round(getAnswerRate * 10000) / 100).toFixed(2) + '%';

                        //   var mydata = {
                        //     testID: datakey,
                        //     groupNo: groupName,
                        //     className: className,
                        //     studentsNumber: testers.length,
                        //     ansRate: getAnswerRate,
                        //     uid: className
                        //   }

                        //groupName改成顯示年班
                        //testData.push(createData(groupName, className, testers.length, getAnswerRate, datakey));
                        testData.push(createData(groupName, className, testers.length, getAnswerRate, datakey));
                    }

                }

            }
        }
        return testData;
    }


    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = event => {
        if (event.target.checked) {
            this.setState(state => ({ selected: state.data.map(n => n.id) }));
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;


    render() {
        const { classes, dataType, tableBtnToTabData, selectTableTab, tableBtnClassResultID, tableBtnClassResult, tableBtnNaniAnswerAnalysis } = this.props;
        var data = this.getData(dataType.userGetReportsData, dataType.classResultID);
        // const { data, order, orderBy, selected, rowsPerPage, page } = this.state;
        var headers = [
            { label: "班級名稱", key: "groupName" },
            { label: "考試人數", key: "number" },
            { label: "答對率", key: "getAnswerRate" }
        ];


        const { order, orderBy, selected, rowsPerPage, page } = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

        function btnAnswerAnalysis(event) {

            var navigations = [true, false, true, true]
            var datakey = "";
            var groupName = "";
            if (event.target.getAttribute("datakey")) {
                datakey = event.target.getAttribute("datakey")
                groupName = event.target.getAttribute("groupName")
            }
            if (event.target.parentElement.getAttribute("datakey")) {
                datakey = event.target.parentElement.getAttribute("datakey")
                groupName = event.target.parentElement.getAttribute("groupName")
            }
            if (event.target.parentElement.parentElement.getAttribute("datakey")) {
                datakey = event.target.parentElement.parentElement.getAttribute("datakey")
                groupName = event.target.parentElement.parentElement.getAttribute("groupName")
            }
            if (event.target.parentElement.parentElement.parentElement.getAttribute("datakey")) {
                datakey = event.target.parentElement.parentElement.parentElement.getAttribute("datakey")
                groupName = event.target.parentElement.parentElement.parentElement.getAttribute("groupName")
            }
            if (datakey != "") {
                tableBtnNaniAnswerAnalysis(navigations, 3, datakey,groupName);
            }
        }

        function GetNowTime() {
            var timeDate = new Date();
            var tMonth = (timeDate.getMonth() + 1) > 9 ? (timeDate.getMonth() + 1) : '0' + (timeDate.getMonth() + 1);
            var tDate = timeDate.getDate() > 9 ? timeDate.getDate() : '0' + timeDate.getDate();
            var tHours = timeDate.getHours() > 9 ? timeDate.getHours() : '0' + timeDate.getHours();
            var tMinutes = timeDate.getMinutes() > 9 ? timeDate.getMinutes() : '0' + timeDate.getMinutes();
            var tSeconds = timeDate.getSeconds() > 9 ? timeDate.getSeconds() : '0' + timeDate.getSeconds();
            // return timeDate= timeDate.getFullYear()+'/'+ tMonth +'/'+ tDate +' '+ tHours +':'+ tMinutes +':'+ tSeconds;
            return timeDate = timeDate.getFullYear() + tMonth + tDate + tHours + tMinutes + tSeconds;
          }

        return (
            <Paper className={classes.root}>
                <Toolbar className={classNames(classes.root)}        >
                    <div className={classes.actions}>
                        <CSVLink data={data} headers={headers} filename={"班級成績" + GetNowTime() + ".csv"}>
                            {/* <CloudDownload />報表下載 */}
                            <Button size="sm" color="primary"><i class="fas fa-cloud-download-alt"></i>報表下載</Button>
                        </CSVLink>
                    </div>
                </Toolbar>
                {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle" fixedHeader={false} style={{ width: "auto", tableLayout: "auto", minWidth: (dataType.isMobile ? "800px" : "1020px") }} >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={this.handleSelectAllClick}
                            onRequestSort={this.handleRequestSort}
                            rowCount={data.length}
                        />
                        <TableBody>
                            {stableSort(data, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(n => {
                                    const isSelected = this.isSelected(n.id);
                                    return (
                                        <TableRow
                                            hover
                                            onClick={event => this.handleClick(event, n.id)}
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            tabIndex={-1}
                                            key={n.id}
                                            selected={isSelected}
                                        >
                                            {/* <TableCell padding="checkbox">
                        <Checkbox checked={isSelected} />
                      </TableCell> */}

                                            <TableCell component="th" scope="row" padding="none">
                                                {n.groupName}
                                            </TableCell>
                                            <TableCell align="right">{n.number}</TableCell>
                                            <TableCell align="right">{n.getAnswerRate}</TableCell>

                                            <TableCell align="right">
                                                <Button color="primary" justIcon={dataType.isMobile} round datakey={n.datakey} groupName={n.groupName} onClick={btnAnswerAnalysis} ><Description style={{ color: "#FFFFFF" }} /> {(dataType.isMobile ? "" : "答題分析")}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 49 * emptyRows }}>
                                    <TableCell colSpan={3} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    labelRowsPerPage="筆數"
                    labelDisplayedRows={({ from, to, count }) => ` ${from}-${to} 總數 ${count} `}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EnhancedTable);


// WEBPACK FOOTER //
// ./src/views/NaniClassResult/NaniClassResult.js